import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
export default class adminFirebase {
  static app = {};
  static isAdminFirebaseInitialized = false;

  static initalize(firebaseDatabaseURL) {
    if (adminFirebase.isAdminFirebaseInitialized !== true) {
      firebase.initializeApp({
        databaseURL: firebaseDatabaseURL,
      });
      adminFirebase.isAdminFirebaseInitialized = true;
    }
  }

  static getDatabaseRef() {
    adminFirebase.adminDatabase = firebase.database();
  }

  static setUserBaseRef(options, bussinessId) {
    if (options && options.userPhone) {
      adminFirebase.userBaseRef = `/crm-data/${bussinessId}/calls/${options.userPhone}`;
    } else {
      adminFirebase.userBaseRef = "";
    }
  }

  static initDatabaseRef(options, bussinessId) {
    adminFirebase.getDatabaseRef();
    adminFirebase.setUserBaseRef(options, bussinessId);
  }

  static registerValueListenerToRef(refName, options, handler) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef(refName, options);
      ref.on(
        "value",
        (snapshot) => {
          data = snapshot.val();
          if (handler) {
            handler(data);
          }
        },
        (err) => console.log(err)
      );
    } else {
      adminFirebase.initialize();
      adminFirebase.registerValueListenerToRef(refName, options, handler);
    }
  }

  static storeSnapshotToLocalDb(refName, snapshot) {
    const ref = refName.split("/").pop();
    try {
      localStorage[ref] = JSON.stringify(snapshot);
    } catch (e) {
      // e
    }
  }

  // forLockingDashboard
  static getDueTaskAlertData(handler) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef("/settings/due_alert_data");
      return ref.once("value", (snapshot) => {
        data = snapshot.val();
        if (data) {
          handler(data);
        }
      });
    }
  }

  static registerOnceListenerToRef(refName, options, handler) {
    let ref;
    let data;

    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef(refName, options);
      return ref.once("value").then((snapshot) => {
        data = snapshot.val();
        return data;
      });
    }
    adminFirebase.initialize();
    adminFirebase.registerOnceListenerToRef(refName, options, handler);
    return null;
  }

  /* Method to check weather to show the call status data or not */
  static isShowCallStatusData(handler) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef("/crm-data/isStatusShowEnabled");
      return ref.once("value").then((snapshot) => {
        data = snapshot.val();
        handler(data);
      });
    }
    return null;
  }
  static isBlocked(phoneNumber, handler, bussinessId) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef(
        `/crm-data/${bussinessId}/calls/${phoneNumber}`
      );
      return ref.once("value").then((snapshot) => {
        data = snapshot.val();
        handler(data);
      });
    }
    return null;
  }

  /* Method to check weather to apply call rules or not */
  static isCallRulesApplied() {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef("/crm-data/isCallRulesApplied");
      return ref.once("value").then((snapshot) => {
        data = snapshot.val();
        return data;
      });
    }
    return null;
  }

  /* Method to get the callDetails for the perticular user number */
  static getCallDetail(userPhone, handler, bussinessId) {
    if (!userPhone && !handler) {
      return;
    }
    if (adminFirebase.isAdminFirebaseInitialized) {
      adminFirebase.getFirebaseCallDetails(
        "/last_calls/",
        {
          userPhone,
        },
        (data) => {
          if (handler) {
            handler(data);
          }
        },
        bussinessId
      );
    }
  }

  static getFirebaseCallDetails(refName, options, handler, bussinessId) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef(refName, options, bussinessId);
      return (
        ref
          .orderByChild("eventEpoch")
          // .orderByKey()
          .limitToLast(1)
          .on("value", (snapshot) => {
            data = snapshot.val();
            if (data) {
              const dataKey = Object.keys(data)[0];
              data = data[dataKey];
              handler(data);
            }
          })
      );
    }
    adminFirebase.initialize();
    adminFirebase.getFirebaseCallDetails(
      refName,
      options,
      handler,
      bussinessId
    );
  }

  static getadminDatabaseRef(refName, options, bussinessId) {
    let ref;
    if (!adminFirebase.adminDatabase) {
      adminFirebase.initDatabaseRef(options, bussinessId);
    }

    if (options && options.userPhone) {
      adminFirebase.setUserBaseRef(options, bussinessId);
      ref = adminFirebase.adminDatabase.ref(
        adminFirebase.userBaseRef + refName
      );
    } else {
      ref = adminFirebase.adminDatabase.ref(refName);
    }

    return ref;
  }

  static getPartnerLocation(identifier, handler) {
    if (!identifier && !handler) {
      return;
    }
    if (adminFirebase.isAdminFirebaseInitialized) {
      adminFirebase.getPartnerLocationDetails(
        `/partnerApp/locationTracking/${identifier}`,
        false,
        (data) => {
          if (handler) {
            handler(data);
          }
        }
      );
    }
  }

  static getPartnerLocationDetails(refName, options, handler) {
    let ref;
    let data;
    if (adminFirebase.isAdminFirebaseInitialized) {
      ref = adminFirebase.getadminDatabaseRef(refName, options);
      return ref.on(
        "value",
        (snapshot) => {
          data = snapshot.val();
          if (data) {
            handler(data);
          }
        },
        (err) => console.log(err)
      );
    }
    adminFirebase.initialize();
    adminFirebase.getPartnerLocationDetails(refName, options, handler);
  }
}
